export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^[1-7]((0[1-9])|(1[0-9])|(20))((0[1-9])|(1[0-6]))$/i));
    }
}
